/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {fromJS} from 'immutable';
import {  Container, Table, Rating, Header, Icon, Pagination, Statistic, Grid, Button, Loader, Feed, Popup, List, Card, Segment, Sidebar, Menu, Label } from 'semantic-ui-react'
import _ from 'lodash';
import moment from 'moment';
import { MARGIN_LEFT } from './Map'

export default class SessionsList extends PureComponent {

  _onSessionClick = (geometry,properties) => {
    this.props.onSessionClickFromList({geometry,properties});
  }


  render() {


    let users = [];


    const {sessions, selectedUser} = this.props;

    users = _.groupBy(sessions, 'properties.userId');
    users = _.orderBy(users, user => user.length,['desc']);
// _.orderBy(features,['properties.timestamp'],['desc'])
    // users = _.orderBy

    // now limit the results to avoid chaos
    // console.log('props',this.props)
    // mySessions.splice(0,40)


    return (

      <div>
        <Menu.Item>
        <Menu.Header>
          <Header as='h1'><Header.Content>Users<Header.Subheader>Sorted by most sessions</Header.Subheader></Header.Content></Header>
        </Menu.Header>



          </Menu.Item>
          {_.map(users, (sessions, userId) => {

            return (
              <Menu.Item

                name={userId} active={selectedUser && selectedUser.userId === sessions[0].properties.userId} as='a'
                key={userId}
                onClick={ ()=> this.props.selectUser(sessions[0]) }
                >
                {sessions[0].properties.username}
                <Label circular color={selectedUser && selectedUser.userId === sessions[0].properties.userId ? 'yellow' : 'grey'}> {sessions.length}</Label>
              </Menu.Item>
            )
          }

          )}

        </div>

    );

  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/users-list.js